import React, { Component } from 'react'
import TagsEditor from '../TagsEditor'
// import Switch from 'react-ios-switch'
import PhotoLoader from '../PhotoLoader'
import { toast } from 'react-toastify'
import './styles/style.css'

class NewsEditor extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props.object
        }
    }

    render() {
        const notSaved = this.state.id === ''
        return (
            <div className="NewsEditorWrapper">
                <div className="ObjectPageWrapper">
                    <div className="ObjectTitleWrapper">
                        <span className="fieldLabel">
                            {'Название'}
                        </span>
                        <input type="text" value={this.state.title} placeholder={'Введите название'} className={'ObjectTitleInput'} onChange={(e) => {
                            this.setState({
                                title: e.nativeEvent.target.value
                            })
                        }} />
                    </div>
                    <div className="PageColumnsWrapper">
                        <div className="PageColumn">
                            <div
                                className={`FieldWrapper ${notSaved ? 'Inactive' : ''}`}
                                onClick={notSaved ? () => {
                                    toast.error(`Сначала сохраните новость`, {
                                        position: toast.POSITION.TOP_RIGHT
                                    })
                                } : undefined}
                            >
                                <span className="fieldLabel">
                                    {'Фото'}
                                </span>
                                <PhotoLoader
                                    filesList={this.state.photo}
                                    onLoad={(filesList) => {
                                        this.setState({
                                            photo: filesList
                                        }, () => {
                                            if (this.props.save) {
                                                this.props.save()
                                            }
                                        })
                                    }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Теги'}
                                </span>
                                <TagsEditor tags={this.state.tags} onChange={(tags) => {
                                    this.setState({
                                        tags: tags
                                    })
                                }} />
                            </div>
                        </div>
                        <div className="PageColumn">

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Дата'}
                                </span>
                                <input placeholder={'Введите дату'} type="text" value={this.state.date} className="FormInput" onChange={(e) => {
                                    this.setState({
                                        date: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Описание'}
                                </span>
                                <textarea value={this.state.descr} className={'FormInputArea'} onChange={(e) => {
                                    this.setState({
                                        descr: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewsEditor


// WEBPACK FOOTER //
// ./src/Components/NewsEditor/index.js